import { BreachEvent } from 'common/events/breachEventTypes'
import { DataLayerEventName } from 'common/helpers/DataLayerEventName'

export function createLinkClickEvent(
    creative: string,
    deal: string,
    onEvent: (event: BreachEvent) => void
): () => void {
    const eventPayload: BreachEvent['payload'] = {
        paywallType: 'freemium',
        leadDepth: 0,
        creative: creative,
        breachScreenType: 'inline',
        popupMethod: 'auto',
        deal: deal,
        pricepoint: [7, 8],
    }

    return () => {
        onEvent({
            type: DataLayerEventName.breachScreenClick,
            originator: 'breachscreen',
            payload: eventPayload,
        })
    }
}
